import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";

// ✅ Import background
import bgImg from "../../images/bg/industries-bg02.png";

// ✅ Company logos (Content for Homepage.pdf — Slide 7)
import logoDS from "../../images/companies/digital-systems.png";
import logoAF from "../../images/companies/appforge.png";
import logoGIQ from "../../images/companies/growth-iq.png";
import logoVS from "../../images/companies/visual-systems.png";
import logoPS from "../../images/companies/platform-systems.png";
import logoET from "../../images/companies/epitech.png";
import logoCX from "../../images/companies/commerce-x.png";
import logoFX from "../../images/companies/flawless-x.png";
import logoVX from "../../images/companies/venture-xcelerator.png";
import logoTFTX from "../../images/companies/the-founders-tx.png";

const IndustriesSection: React.FC = () => {
  useEffect(() => {
    // ✅ Set background dynamically (optional)
    const section = document.querySelector<HTMLElement>(".industries.bg-wrap");
    if (section) {
      section.style.backgroundImage = `url(${bgImg})`;
    }
  }, []);

  // ✅ 10 Corporate Companies — logo + tagline (Homepage PDF, Slide 7)
  const companies = [
    { logo: logoDS, title: "Digital Systems", tagline: "Intelligent Web Solutions" },
    { logo: logoAF, title: "AppForge", tagline: "Mobile & Digital Product Engineering" },
    { logo: logoGIQ, title: "Growth IQ", tagline: "Digital Marketing & Growth Solutions" },
    { logo: logoVS, title: "Visual Systems", tagline: "Branding & Creative Design" },
    { logo: logoPS, title: "Platform Systems", tagline: "Enterprise Platform Development" },
    { logo: logoET, title: "EpiTech", tagline: "Skills & Technology Education" },
    { logo: logoCX, title: "Commerce X", tagline: "E-Commerce Solutions" },
    { logo: logoFX, title: "Flawless X", tagline: "Quality Engineering & Software Testing" },
    { logo: logoVX, title: "Venture Xcelerator", tagline: "Startup & Venture Development" },
    {
      logo: logoTFTX,
      title: "The Founders TX",
      tagline: "Year-round innovation platform for founders, investors & educators",
    },
  ];

  return (
    <section className="industries pb-165 bg_img bg-wrap">
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-50">
          <span className="sub-title mb-15">Corporate Companies</span>
          <h2 className="title">Specialized companies under the KOT umbrella</h2>
        </div>
      </div>

      {/* 10 Corporate Companies — sirf logo + tagline (title removed) */}
      <div className="xb-industries-wrapper d-inline-block">
        <Marquee
          direction="right"
          speed={40}
          gradient={false}
          pauseOnHover={true}
          className="marquee-right"
        >
          <div className="xb-industries-inner ul_li">
            {companies.map((item, index) => (
              <div className="xb-industries-item xb-border" key={index}>
                <div className="xb-logo">
                  <img src={item.logo} alt={item.title} />
                </div>
                {/* tagline — filhal comment (user request) */}
                {/* <span className="xb-tagline">{item.tagline}</span> */}
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default IndustriesSection;
